import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
	return (
		<section
			className="pt-0 position-relative overflow-hidden h-700px h-sm-600px h-lg-700px rounded-top-4 mx-2 mx-md-4"
			style={{
				backgroundImage: "url(assets/images/bg/03.jpg)",
				backgroundPosition: "center",
				backgroundSize: "cover",
			}}
		>
			<div className="bg-overlay bg-dark opacity-5" />
			{/* SVG decoration for curve */}
			<figure className="position-absolute bottom-0 left-0 w-100 d-md-block mb-n3 z-index-9">
				<svg
					className="fill-body"
					width="100%"
					height={150}
					viewBox="0 0 500 150"
					preserveAspectRatio="none"
				>
					<path d="M0,150 L0,40 Q250,150 500,40 L580,150 Z" />
				</svg>
			</figure>
			<div className="container z-index-9 position-relative">
				<div className="row py-0 py-md-5 align-items-center text-center text-sm-start">
					<div className="col-sm-10 col-lg-8 col-xl-6 all-text-white my-5 mt-md-0">
						<div className="animate-move-y">
							<div className="p-2 card card-body bg-orange shadow position-absolute top-0 start-0 translate-middle z-index-1 d-none d-sm-block beta-position">
								<div className="d-flex justify-content-between align-items-center">
									<h6 className="mb-0 small mb-0 text-white">
										<b>BETA</b>
									</h6>
								</div>
							</div>
						</div>
						<div className="py-0 py-md-5 my-5">
							{/* Title */}
							<h1 className="text-white display-5 mb-0">
								<div className="knows-green1">LMS M-KNOWS </div>
							</h1>
							<h5 className="text-white mb-3">
								Solusi Optimalkan Produktivitas dan Efektivitas Kerja
							</h5>
							<p className="text-white">
								LMS M-Knows adalah Platform pelatihan yang berbasis Web dan
								Mobile Apps yang digunakan untuk mengelola Program pelatihan
								karyawan yang bisa di akses kapanpun dan dimanapun.
							</p>
							<div className="d-sm-flex align-items-center mt-4">
								{/* Button */}
								<Link
									to="/silabus"
									className="btn bg-knows-green1 text-black me-2 mb-4 mb-sm-0"
								>
									Get Started
								</Link>
								{/* Video button */}
								<div className="d-flex align-items-center justify-content-center py-2 ms-0 ms-sm-4">
									<a
										data-glightbox
										data-gallery="office-tour"
										href="https://youtu.be/FpfAmsrf8kc"
										className="btn btn-round btn-white-shadow text-danger me-7 mb-0 overflow-visible"
									>
										<i className="fas fa-play" />
										<h6 className="mb-0 ms-3 text-white fw-normal position-absolute start-100 top-50 translate-middle-y">
											Watch video
										</h6>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default HeroSection;
